module.exports = __webpack_public_path__ + "media/images/top-11-b4cc9368ac903172243b9aba830322da.png";